export const MAX_ROUTE_NAME_LENGTH = 25;
export const MAX_TRAP_NAME_LENGTH = 25;
